import { UserWithRole } from "./types";

export const defaultUser: UserWithRole = {
  id: "",
  email: "",
  username: "",
  password: "",
  firstName: "",
  lastName: "",
  emailVerified: new Date(),
  roles: [{ roleid: "", userId: "", role: { id: "", Role: "", spaceId: "" } }],
  locations: [],
  viewAllLocations: false,
  active: false,
  spaceId: "",
  space: {
    address: null,
    companyName: null,
    currencyMark: null,
    email: null,
    emailLabel: null,
    fax: null,
    homeCurrency: null,
    id: "",
    increment: 0,
    name: "",
    createdById: null,
    lastUpdatedById: null,
    subdomain: "",
    phone: null,
    sendgridAPIKey: null,
    timezone: null,
    validationOptions: [],
    lastModified: null,
    dateCreated: new Date(),
    active: true,
    logo: {},
  },
  mainSuperAdmin: false,
  invitationStatus: null,
  invitationSentDate: null,
  resetToken: "",
  currentLocationId: "",
  apiKey: "",
  apiKeyIntegration: null,
  apiUserIncrement: null,
  createdById: null,
  lastModified: null,
  dateCreated: new Date(),
  lastLogin: null,
};
